/**
 * @flow
 * @relayHash ef35b05d1e2f7a6e6050fa685a0ade7d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ArticleSelector_viewer$ref = any;
type Stream_stream$ref = any;
type TopicSelector_viewer$ref = any;
export type MediaFileTypeEnum = "image" | "live" | "video" | "wallpaper" | "%future added value";
export type queries_Stream_QueryVariables = {|
  id: string,
  type?: ?MediaFileTypeEnum,
|};
export type queries_Stream_QueryResponse = {|
  +stream: ?{|
    +$fragmentRefs: Stream_stream$ref
  |},
  +viewer: ?{|
    +streamUrls: ?{|
      +mediaFiles: ?$ReadOnlyArray<?{|
        +id: string,
        +title: ?string,
        +filename: ?string,
      |}>
    |},
    +$fragmentRefs: TopicSelector_viewer$ref & ArticleSelector_viewer$ref,
  |},
|};
export type queries_Stream_Query = {|
  variables: queries_Stream_QueryVariables,
  response: queries_Stream_QueryResponse,
|};
*/


/*
query queries_Stream_Query(
  $id: ID!
  $type: MediaFileTypeEnum
) {
  stream: node(id: $id) {
    __typename
    ...Stream_stream
    id
  }
  viewer {
    streamUrls: mediaFilesPaginate(pageSize: 100, page: 1, type: $type) {
      mediaFiles {
        id
        title
        filename
      }
    }
    ...TopicSelector_viewer
    ...ArticleSelector_viewer
    id
  }
}

fragment Stream_stream on Stream {
  id
  title
  slug
  video
  state
  topics {
    id
    name
  }
  videoFile {
    id
    filename
    description
  }
  preview {
    id
    filename
  }
  screen
  rating
  active
  linkedArticles {
    id
    title
  }
  description
  availableAt
}

fragment TopicSelector_viewer on Viewer {
  topicsForSelector: topics(first: -1) {
    edges {
      node {
        id
        name
      }
    }
  }
}

fragment ArticleSelector_viewer on Viewer {
  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {
    articles {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "MediaFileTypeEnum",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "page",
  "value": 1,
  "type": "Int"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "filename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": "streamUrls",
  "name": "mediaFilesPaginate",
  "storageKey": null,
  "args": [
    v2,
    {
      "kind": "Literal",
      "name": "pageSize",
      "value": 100,
      "type": "Int"
    },
    {
      "kind": "Variable",
      "name": "type",
      "variableName": "type",
      "type": "MediaFileTypeEnum"
    }
  ],
  "concreteType": "mediaFilesPaginate",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mediaFiles",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": true,
      "selections": [
        v3,
        v4,
        v5
      ]
    }
  ]
},
v7 = [
  v3,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v9 = [
  v3,
  v4
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_Stream_Query",
  "id": null,
  "text": "query queries_Stream_Query(\n  $id: ID!\n  $type: MediaFileTypeEnum\n) {\n  stream: node(id: $id) {\n    __typename\n    ...Stream_stream\n    id\n  }\n  viewer {\n    streamUrls: mediaFilesPaginate(pageSize: 100, page: 1, type: $type) {\n      mediaFiles {\n        id\n        title\n        filename\n      }\n    }\n    ...TopicSelector_viewer\n    ...ArticleSelector_viewer\n    id\n  }\n}\n\nfragment Stream_stream on Stream {\n  id\n  title\n  slug\n  video\n  state\n  topics {\n    id\n    name\n  }\n  videoFile {\n    id\n    filename\n    description\n  }\n  preview {\n    id\n    filename\n  }\n  screen\n  rating\n  active\n  linkedArticles {\n    id\n    title\n  }\n  description\n  availableAt\n}\n\nfragment TopicSelector_viewer on Viewer {\n  topicsForSelector: topics(first: -1) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment ArticleSelector_viewer on Viewer {\n  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {\n    articles {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_Stream_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "stream",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Stream_stream",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v6,
          {
            "kind": "FragmentSpread",
            "name": "TopicSelector_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "ArticleSelector_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_Stream_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "stream",
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          v3,
          {
            "kind": "InlineFragment",
            "type": "Stream",
            "selections": [
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "video",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "topics",
                "storageKey": null,
                "args": null,
                "concreteType": "Topic",
                "plural": true,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "videoFile",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": false,
                "selections": [
                  v3,
                  v5,
                  v8
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "preview",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": false,
                "selections": [
                  v3,
                  v5
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "screen",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rating",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "linkedArticles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": v9
              },
              v8,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "availableAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v6,
          {
            "kind": "LinkedField",
            "alias": "topicsForSelector",
            "name": "topics",
            "storageKey": "topics(first:-1)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              }
            ],
            "concreteType": "TopicConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TopicEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Topic",
                    "plural": false,
                    "selections": v7
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "articlesForSelector",
            "name": "articlesPaginate",
            "storageKey": "articlesPaginate(hidden:false,page:1,pageSize:5)",
            "args": [
              {
                "kind": "Literal",
                "name": "hidden",
                "value": false,
                "type": "Boolean"
              },
              v2,
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 5,
                "type": "Int"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": v9
              }
            ]
          },
          v3
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '87c86e698c9473cb4e23476211c54943';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_Stream_Query.graphql.js